var map = {
	"./task-cant-complete-selected.svg": 435,
	"./task-cant-complete.svg": 863,
	"./task-completed-selected.svg": 436,
	"./task-completed.svg": 864,
	"./task-rescheduled-selected.svg": 437,
	"./task-rescheduled.svg": 865
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2001;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/task\-.*\.svg$
// module id = 2001
// module chunks = 0